export const PLANNING_REDUCER = 'planningReducer';
export const COMPARABLE_REDUCER = 'comparableReducer';
export const OWNERSHIP_REDUCER = 'ownershipReducer';
export const SEARCH_REDUCER = 'search';